export const storage = {
	get: (name) => localStorage.getItem(name),
	remove: (name) => localStorage.removeItem(name),
	set: (name, value) => localStorage.setItem(name, value),
};

export const getRandomNumber = (min, max) => {
	return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const buildAuthLink = (provider, promoHash) => {
	const base = `/login/${provider}?route=event`;

	return promoHash ? `${base}&uri=/c/${encodeURIComponent(promoHash)}` : base;
};
